export default {
  customBackground: {
    label: 'Personnalisé',
    hint: 'JPEG · PNG · max. 5 Mo',
    uploadAriaLabel: 'Téléverser un arrière-plan personnalisé',
    replaceAriaLabel: "Remplacer l'image d’arrière-plan",
    previewAlt: 'Aperçu de l’arrière-plan',
    savedAlt: 'Arrière-plan enregistré',
    save: 'Enregistrer',
    change: 'Modifier',
    cancel: 'Annuler',
    replace: 'Remplacer',
    saving: 'Enregistrement…',
    errorTitle: 'Échec du téléversement',
    errorType: 'Seules les images JPEG et PNG sont acceptées.',
    errorSize: 'Le fichier dépasse la limite de 5 Mo. Veuillez choisir une image plus petite.',
    errorSave: 'Impossible d’enregistrer l’image. Veuillez réessayer.',
    errorUnknown: 'Fichier invalide. Veuillez réessayer.',
  },
};
